import { Box } from '../global/box.js';

export class Offer extends Box {
    constructor(element) {
        super(element);
        this._isFree = false;
        this._initCreditCard = false;
        this._trackType = 'offer';
        this._offerInput = document.querySelector('[name="order[product]"]');
        this._upsellInput = document.querySelector('[name="order[upselling]"]');

        this.init();
    }

    get title() {
        return this._json.fields['produkt-info'] || this._json.teaser;
    }

    get prices() {
        return this._json.prices;
    }

    get deliveryStart() {
        return this._json.fields.lieferbeginn || false;
    }

    get forerun() {
        return this._json.fields.vorlauf || 0;
    }

    get drerz() {
        return (this._json.fields.druckerzeugnis || '').toUpperCase();
    }

    get runtime() {
        return this._json.fields.laufzeit || 0;
    }

    get payments() {
        return this._json.paymethods;
    }

    get faktura() {
        return this._json.payintervals || [];
    }

    get url() {
        return this._element.dataset.url || false;
    }

    get isOffer() {
        return this._holder.classList.contains('offers');
    }

    get isUpsell() {
        return this._holder.classList.contains('upsellings');
    }
    
    get isFree() {
        return this._json.paymethods.includes('free') || false;
    }

    get fixDeliveryStart() {
        return Boolean(this._json.fields.fixDeliveryStart) || false;
    }
    
    init() {
        super.init();
        this._element.addEventListener('click', event => {
            event.preventDefault();
            if (this.isUpsell) {
                (this.isSelected) ? this.unselect() : this.select();
            } else if (!this.isSelected) {
                this.select();
            }
        });
    }

    select() {
        if(this.url) {
            window.location.href = this.url;
            return;
        }
        
        (this.isUpsell) ? this.fireEvent('unselectAllUpsells') : this.fireEvent('unselectAllOffers');
        this.fireEvent('selectOffer', {offer: this});
        this.update();
        super.select();
    }
    
    unselect() {
        this.fireEvent('unselectOffer', {offer: this});
        super.unselect();
    }

    update() {
        if (this._offerInput) {
            this._offerInput.value = this.id;
        }

        if (this.isUpsell && this._upsellInput) {
            this._upsellInput.value = this.id;
        }
    }
}
